import { useEffect, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import LogsTable from "../components/LogsTable";
import UserActivityTable from "../components/UserActivityTable";

type TabValue = "logs" | "users";
const TAB_STORAGE_KEY = "logPage.tab";

const LogPage = () => {
  const [tab, setTab] = useState<TabValue>("logs");

  useEffect(() => {
    const storedTab = localStorage.getItem(TAB_STORAGE_KEY);
    if (storedTab === "logs" || storedTab === "users") {
      setTab(storedTab);
    }
  }, []);

  const handleTabChange = (_: unknown, value: TabValue) => {
    setTab(value);
    localStorage.setItem(TAB_STORAGE_KEY, value);
  };

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1, p: 2 }}>
      <Typography variant="h5">📒Logs</Typography>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        aria-label="log tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Logs" value="logs" />
        <Tab label="Users" value="users" />
      </Tabs>
      <Box sx={{ flex: 1 }}>
        {tab === "logs" && <LogsTable />}
        {tab === "users" && <UserActivityTable />}
      </Box>
    </Box>
  );
};

export default LogPage;
